// create a blot - which creates a node which is used for semantic meaning, vs. just an inline format and no semantic meaning
import Embed from "quill/blots/embed";


class ADMBlot extends Embed {
    static tagName = "span";
    static blotName = "adm-blot";
    /*
    the only way for quill/parchment to distinguish between HTML structures like span or div is by setting a static className
    otherwise subsequent copy/paste etc. actions may change your Blot into a different type
     */
    static className = "ql-adm-variable";

    static create(data) {
        let node = super.create(data);

        return node;
    }

    constructor(domNode, data) {
        super(domNode, data);
        domNode.setAttribute('contenteditable', false);
        if (data.group) {
            domNode.innerText = `${data.group} »${data.label}`;
            domNode.setAttribute('data-group', data.group);
        } else {
            domNode.innerText = data.label;
        }
        domNode.setAttribute('data-value', data.value);
        domNode.setAttribute('data-label', data.label);
    }

    /*
    * this is the insert text you would pass to Delta on an insert
    * needed when working backwards to accept HTML and create blot?
    *  used by dangerouslyPasteHTML to the editor when it's initialized witha  default value, e.g. after validation fails on form submit.
    *  otherwise it'll have undefined for the data- attributes even though the html passed to it has it correct
     */
    static value(node) {
        let data = {
            value: node.getAttribute('data-value'),
            label: node.getAttribute('data-label'),
        }
        if (node.getAttribute('data-group')) {
            data.group = node.getAttribute('data-group')
        }
        return data;
    }
}

export {
    ADMBlot,
}
